import React, { useState, ReactNode } from 'react'
import AnimateHeight from 'react-animate-height'

import { Icon } from 'components/ui'
import { Wrap, Header, Title, IconWrap, ContentWrap, Content } from './Style'

type Props = {
  title: string
  isOpen?: boolean
  tooltipId?: string
  maxHeight?: string
  component?: ReactNode
  children: ReactNode
  toggle?: (isOpen: boolean) => void
}

type Height = 'auto' | number | `${number}%`

const Dropdown = ({ title, toggle, children, component, isOpen = false, maxHeight = 'fit-content' }: Props) => {
  const [showElement, setShowElement] = useState(isOpen)
  const [height, setHeight] = useState<Height>(isOpen === true ? 'auto' : 0)

  const handleClick = () => {
    setShowElement(!showElement)
    if (typeof toggle === 'function') {
      toggle(!showElement)
    }
    setHeight(height === 0 ? 'auto' : 0)
  }

  return (
    <Wrap>
      <Header
        isOpen={showElement}
        onClick={handleClick}
        aria-controls='toggle'
        aria-expanded={showElement ? 'true' : 'false'}
      >
        <Title id={title}>{title}</Title>

        <IconWrap>
          {component}
          <Icon name='chevron' rotate='0deg' size='large' />
        </IconWrap>
      </Header>

      <AnimateHeight id={title} duration={400} height={height}>
        <ContentWrap>
          <Content maxHeight={maxHeight}>{children}</Content>
        </ContentWrap>
      </AnimateHeight>
    </Wrap>
  )
}

export { Dropdown }
